export const HTTP_OK = 200;
export const HTTP_NOT_FOUND = 404;
export const HTTP_UNAUTHORIZED = 403;



// WEBPACK FOOTER //
// ./src/api/helpers/httpStatuses.js